import { render, staticRenderFns } from "./Safe.vue?vue&type=template&id=0ed0967c&scoped=true&"
import script from "./Safe.vue?vue&type=script&lang=js&"
export * from "./Safe.vue?vue&type=script&lang=js&"
import style0 from "./Safe.vue?vue&type=style&index=0&id=0ed0967c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed0967c",
  null
  
)

export default component.exports